/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:ab8640c2-a8f2-4723-97d1-0afbc5bc0f38",
    "aws_cognito_region": "us-east-2",
    "oauth": {},
    "aws_mobile_analytics_app_id": "2662194e60574010818bc531c70c7948",
    "aws_mobile_analytics_app_region": "us-east-1"
};


export default awsmobile;
